import Slide1Ingestion from "./usecases/Slide1Ingestion";
import Slide2Analysis from "./usecases/Slide2Analysis";
import Slide3Modularity from "./usecases/Slide3Modularity";
import Slide4UseCasesCarousel from "./usecases/Slide4UseCasesCarousel";
import Slide5QuickStart from "./usecases/Slide5QuickStart";

export const useCases = [
  Slide1Ingestion,
  Slide2Analysis,
  // Slide3Modularity,
  // Slide4UseCasesCarousel,
  // Slide5QuickStart,
];
